
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { Button, Card, Form, Input, Container, Row, Col, FormGroup, Label } from "reactstrap";
import ReactNotificationAlert from "react-notification-alert";
import BackToLogin from "components/BackToLogin";

import NotificationAlert from "react-notification-alert";
import notificationManager from "managers/notificationManager";

import { staticData } from "managers/staticDataManager";
import { useFormik } from "formik";

import { resetPasswordVlidationSchema, initialResetPasswordModal } from "../validations";
import { handleResetPassword } from "../callApi";

const ResetPassword = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("register-page");
    return function cleanup() {
      document.body.classList.remove("register-page");
    };
  });

  const { token } = useParams();
  const notificationAlertRef = React.useRef(null);
  const state = useSelector((state) => state);
  const [isBusy, setIsBusy] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const validationSchema = resetPasswordVlidationSchema(state);

  const formik = useFormik({
    initialValues: initialResetPasswordModal,
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (data) => {
      handleResetPassword(state, token, data, setIsBusy, setIsSuccess, notificationAlertRef);
    },
  });

  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="4">
            <Card className="card-register ml-auto mr-auto">
              <Form onSubmit={formik.handleSubmit} hidden={isSuccess}>
                  <FormGroup>
                      <Label className="form-check-label" for="formNewPassword" style={{fontWeight: 'bold'}}>{staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_formNewPassword")}</Label>
                      <Input id="formNewPassword" name="newPassword" type="password" 
                          disabled={isBusy} onChange={formik.handleChange} value={formik.values.newPassword}/>
                      <div className="text-danger-black" style={{fontWeight: 'bold'}}>
                          {formik.errors.newPassword ? formik.errors.newPassword : null}
                      </div>
                  </FormGroup>
                  <FormGroup>
                      <Label className="form-check-label" for="formConfirmPassword" style={{fontWeight: 'bold'}}>{staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_formConfirmPassword")}</Label>
                      <Input id="formConfirmPassword" name="confirmPassword" type="password" 
                          disabled={isBusy} onChange={formik.handleChange} value={formik.values.confirmPassword}/>
                      <div className="text-danger-black" style={{fontWeight: 'bold'}}>
                          {formik.errors.confirmPassword ? formik.errors.confirmPassword : null}
                      </div>
                  </FormGroup>              
                  <Button block className="btn-round" color="danger" disabled={isBusy}>
                    {staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_BtnConfirm")}
                  </Button>
              </Form>
              <div hidden={!isSuccess}>
                <div className="card-body">
                    <div><b>{staticData.loadTerms(state, "VW_ISSUER_ResetPassword_DoneMessage")}</b></div>
                </div>
              </div>
              <BackToLogin />
            </Card>
          </Col>
        </Row>
      </Container>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
    </React.Fragment>
  );
}

export default ResetPassword;
